/**
 * AppDownloadSection Component
 * CTA for downloading the Talk Australia mobile app.
 * Appears in midmarket and enterprise tiers.
 */

import React from 'react';

const styles = {
  section: {
    padding: '60px 20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: '#1A2332',
    borderRadius: '16px',
    border: '1px solid #2A3444',
    padding: '48px 40px',
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  mockup: {
    width: '140px',
    height: '260px',
    borderRadius: '24px',
    background: 'linear-gradient(135deg, #0057FF 0%, #00D4AA 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 20px 40px rgba(0, 87, 255, 0.2)',
    flexShrink: 0,
    position: 'relative',
    overflow: 'hidden',
  },
  mockupNotch: {
    position: 'absolute',
    top: '8px',
    width: '50px',
    height: '6px',
    borderRadius: '3px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  mockupLogo: {
    fontSize: '36px',
    color: '#FFFFFF',
    fontWeight: '800',
    marginBottom: '4px',
  },
  mockupText: {
    fontSize: '10px',
    color: 'rgba(255, 255, 255, 0.8)',
    fontWeight: '600',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  content: {
    flex: 1,
    minWidth: '280px',
  },
  badge: {
    display: 'inline-block',
    padding: '6px 14px',
    backgroundColor: 'rgba(0, 87, 255, 0.15)',
    color: '#5B9DFF',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    marginBottom: '16px',
  },
  title: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '12px',
    lineHeight: '1.3',
  },
  description: {
    fontSize: '15px',
    color: '#8B92A5',
    lineHeight: '1.6',
    marginBottom: '24px',
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '28px',
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
    color: '#BBBEC7',
  },
  featureCheck: {
    color: '#00D4AA',
    fontSize: '16px',
    fontWeight: '700',
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  storeButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 24px',
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '10px',
    color: '#FFFFFF',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  storeIcon: {
    fontSize: '24px',
  },
  storeTextWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  storeLabel: {
    fontSize: '10px',
    color: '#8B92A5',
    lineHeight: '1',
  },
  storeName: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '1.2',
  },
};

const FEATURES = [
  'Lodge support tickets from anywhere',
  'View service status in real time',
  'Manage users and devices',
  'Push notifications for updates',
];

function AppDownloadSection({ prospect }) {
  return (
    <div style={styles.section}>
      <div style={styles.card}>
        {/* Phone mockup */}
        <div style={styles.mockup}>
          <div style={styles.mockupNotch} />
          <span style={styles.mockupLogo}>TA</span>
          <span style={styles.mockupText}>Talk Australia</span>
        </div>

        {/* Content */}
        <div style={styles.content}>
          <div style={styles.badge}>Coming Soon</div>
          <h2 style={styles.title}>Manage Everything From Your Pocket</h2>
          <p style={styles.description}>
            The Talk Australia app gives {prospect?.companyName || 'your team'} full portal
            access from any device. Support tickets, service monitoring, and account management
            — all at your fingertips.
          </p>

          <div style={styles.features}>
            {FEATURES.map((feature) => (
              <div key={feature} style={styles.feature}>
                <span style={styles.featureCheck}>\u2713</span>
                <span>{feature}</span>
              </div>
            ))}
          </div>

          <div style={styles.buttons}>
            <a href="#" style={styles.storeButton}>
              <span style={styles.storeIcon}>\uF8FF</span>
              <div style={styles.storeTextWrap}>
                <span style={styles.storeLabel}>Download on the</span>
                <span style={styles.storeName}>App Store</span>
              </div>
            </a>
            <a href="#" style={styles.storeButton}>
              <span style={styles.storeIcon}>\u25B6</span>
              <div style={styles.storeTextWrap}>
                <span style={styles.storeLabel}>Get it on</span>
                <span style={styles.storeName}>Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppDownloadSection;
